'use strict';

import React from 'react'
import {render} from 'react-dom'
import {Provider} from 'react-redux'
import {createStore, applyMiddleware} from 'redux'
import thunkMiddleware from 'redux-thunk'
import createLogger from 'redux-logger'
import galleryReducers from '../../reducers/index.js'
import GalleryContainer from './galleryContainer.js';
import ItemLayout from '../item/itemLayout.js';
import {utils} from '../../utils'
import {logger} from '../../utils'
import {create} from 'fedops-logger'

logger.initBiLoadedEventListener('gallery');

class ProGalleryServices {

  constructor() {
    utils.timingMeasure('ProGallery start', 'navigationStart')
    try {
      window.fedopsLogger = create('pro-gallery-statics')
      fedopsLogger.appLoaded()
    } catch(e) {
      console.error('fedopsLogger: apploaded failed', e)
    }
    this.gallerySrcTypes = { //gallery source types
      sampleImages: 'sampleImages',
      itemsFromWixCode: 'itemsFromWixCode',
      prerenderedGallery: 'prerenderedGallery',
      albumSetFromBuilder: 'albumSetFromBuilder',
      manuallySetImages: 'manuallySetImages'
    };

    const middlewares = [thunkMiddleware];

    const shouldLogRedux = false
    if (utils.isDev() && shouldLogRedux) {
      const loggerMiddleware = createLogger({diff:true});
      middlewares.push(loggerMiddleware)
    }

    this.store = createStore(galleryReducers, applyMiddleware(...middlewares))

    if (utils.isDev()) {
      console.log('initial store state', this.store.getState());
    }

    let unsubscribe = this.store.subscribe(() => {
      if (utils.isDev()) {
        console.log('store update', this.store.getState());
      }
    });

    $(document).ready(() => {
      this.content = document.getElementById('content');

      //this.galleryScrollEvent = document.createEvent('CustomEvent');  // MUST be 'CustomEvent'
      //this.galleryScrollEvent.initCustomEvent('images_changed', false, false, null);
      this.populateGalleryData();

      this.renderGallery();
    });
  }

  updateServerMappingIfNeeded(setId, isDuringPublish, callback) {
    if (!isDuringPublish) {
      callback()
      return;
    }
    if (setId === 'fake_set') {
      callback()
      return;
    }

    // if (window.petri['specs.NewProvisionFlow'] === 'true') {
    //   return;
    // }

    if ((this.mappingUpdatedInstanceId !== Wix.Utils.getInstanceId()) &&
      (utils.getViewModeFromCache() === 'editor' || utils.getViewModeFromCache() === 'preview') &&
      Wix.Utils.getDemoMode() === false) {

      this.mappingUpdatedInstanceId = Wix.Utils.getInstanceId();
      //URL - http://progallery.wix.com/api/v1/albums/map-set-id
      //Body (json) {"instanceId" : "8e3502cb-25ee-4d7f-b8c3-96034fe36911", "compId" : "compId2", "setId": "75cda6bb-c060-4381-930a-beb9a22c027a"}
      var mappingData = {instanceId: Wix.Utils.getInstanceId(), compId: Wix.Utils.getCompId(), setId: setId};
      $.ajax({
        type: 'POST',
        url: '/api/v1/albums/map-set-id',
        data: JSON.stringify (mappingData),
        success: (res) => {
          console.log('Success in mapping gallery to set', mappingData);
          callback()
        },
        error: (err) => {
          console.error('Failed to map gallery to set', err);
          callback()
        },
        contentType: 'application/json'
      });
    }
  }

  getImagesFromBuilder() {
    if (utils.isDev()) {
      console.log('Gallery Services - getImagesFromBuilder');
    }

    if (window.document.domain != 'wix.com') {
      try {
        //noinspection JSAnnotator
        window.document.domain = 'wix.com';
      } catch (e) {
        console.warn('Failed to set wix.com domain');
      }
    }

    //replace the current set of images on the window
    try {
      var activeAlbum = window.parent.parent['activeAlbum'];
      const isDuringPublish = _.get(activeAlbum, 'serverStatus.duringUpdate');
      var albumSet = activeAlbum.getSetByGalleryId(Wix.Utils.getCompId()); //getSetByGalleryId is in albums code
      if (albumSet.id) {
        this.updateServerMappingIfNeeded(albumSet.id, isDuringPublish, () => {

          try {
            albumSet.mapSetIdCallback();
          } catch(e) {
            console.log("couldn't call mapSetIdCallback", e);
          }

        });
        return albumSet.getSetJson(); ////getSetJson is in albums code
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  populateGalleryData() {
    try {
      //replace the current set of images on the window

      let galleryData;
      let galleryDataSrcName;

      let albumSetFromBuilder = this.getImagesFromBuilder();
      if (window.manuallySetImages) {
        galleryData = window.manuallySetImages;
        this.galleryDataSrc = this.gallerySrcTypes.manuallySetImages
        galleryDataSrcName = 'manuallySetImages';
      } else if (window['itemsFromWixCode']) {
        galleryData = {photos: window['itemsFromWixCode']};
        this.galleryDataSrc = this.gallerySrcTypes.albumSetFromBuilder;
        galleryDataSrcName = 'itemsFromWixCode';
      } else if (albumSetFromBuilder) {
        galleryData = albumSetFromBuilder;
        this.galleryDataSrc = this.gallerySrcTypes.albumSetFromBuilder;
        galleryDataSrcName = 'albumSetFromBuilder';
      } else if (window['prerenderedGallery']) {
        galleryData = {photos: window['prerenderedGallery']['items']};
        this.galleryDataSrc = this.gallerySrcTypes.prerenderedGallery;
        galleryDataSrcName = 'prerenderedGallery';
      } else {
        //no prerender gallery
        if (utils.isSite() && !utils.isDev()) {
          console.error('prerendered gallery is missing');
          logger.trackBi(logger.biEvents.pro_gallery_error, {errorType: 'prerenderedGalleryMissing'});
        }
        galleryData = utils.isDev() ? window['sampleImages'] : window['emptyImages'];
        this.galleryDataSrc = this.gallerySrcTypes.sampleImages;
        galleryDataSrcName = 'sampleImages/emptyImages';
      }

      if (utils.isDev()) {
        console.log('Populating gallery data from: ' + galleryDataSrcName);
      }

      const _galleryData = window['galleryData'] = galleryData;
      const _itemsCount = (this.galleryDataSrc == this.gallerySrcTypes.prerenderedGallery) ? window['prerenderedGallery']['totalItemsCount'] : (this.galleryData && this.galleryData.photos.length);

      if (this.galleryData) {

      } else {
        this.galleryData = _galleryData;
        this.itemsCount = _itemsCount;
      }

    } catch (e) {
      console.error('Could not populate gallery data', e);
    }
  }

  itemsToDto(items) {
    return _.map(items, (item) => {
      item.createdBy = 'itemsToDto';
      return (new ItemLayout({dto: item})).dto;
    })
  }

  getItemsDto() {
    var items = this.galleryData && this.galleryData.photos;
    items = items || [];
    return this.itemsToDto(items);
  }

  getAllItemsDto(callback) {
    this.getAllItemsFromServer(callback);
    return this.itemsToDto(this.galleryData && this.galleryData.photos);
  }

  getAllItemsFromServer(callback) {
    var fetchedItems = this.galleryData && this.galleryData.photos;

    if (_.isUndefined(this.itemsCountToFetch) || this.itemsCountToFetch === false) {
      this.itemsCountToFetch = this.itemsCountToFetch || this.itemsCount;
    }

    let fetchCount = Math.min(1000, this.itemsCountToFetch - fetchedItems.length);
    if (fetchCount <= 0) { //end
      this.itemsCountToFetch = false;
      callback(this.itemsToDto(this.galleryData.photos));
    } else {
      this.getItemsFromServer(fetchedItems.length, fetchedItems.length + fetchCount).done((res) => {
        this.addImages(res.items);
        this.getAllItemsFromServer(callback);
      }).fail((err) => {
        console.error('failed to get items from server', (err && err.message));
      });
    }
  }

  getItemsFromServer (from, to) {
    let storeParameter = '';
    if (utils.isStoreGallery()) {
      storeParameter = `&isStore=true`;
    }
    return $.ajax({
      url: `${window.infiniteScrollUrl}from/${from}/to/${to}?instance=${window.instance}${storeParameter}`,
      xhrFields: {
        withCredentials: true
      }});
  }

  isDisplayingDefaultImages() {

    try {
      var manuallySetImages = window.manuallySetImages;
      var albumSetFromBuilder = this.getImagesFromBuilder();
      var galleryFromVm = window['prerenderedGallery'] ? {photos: window['prerenderedGallery']['items']} : false;

      return !(manuallySetImages || galleryFromVm || albumSetFromBuilder);
    } catch (e) {
      console.error('Error checking if displaying default images', e);
      return false;
    }
  }

  setImages(images) {

    if (utils.isDev()) {
      console.log('Gallery Services - setImages', images);
    }

    //update selected images in the current set of images on the window
    if (typeof images != 'object') {
      console.error('Trying to use addImages with illegal images', images);
    }
    if (!(images.length > 0)) {
      images = [images];
    }
    if (!this.galleryData) {
      this.populateGalleryData();
    }

    try {
      this.galleryData.photos = window.manuallySetImages = images;
      this.itemsCount = this.galleryData.photos.length;
      this.galleryDataSrc = this.gallerySrcTypes.manuallySetImages;
      window.infiniteScrollUrl = ''; //diasble infinite scroll when setting images manually
    } catch (e) {
      console.error("Cannot set new images", e, images, window);
    }

    // if (this.galleryView) {
    //   this.galleryView.renderTrigger = this.galleryView.renderTriggers.ITEMS; //this is a patch, we need to find a better way to control setState without predefined data
    //   this.galleryView.setState({items: this.galleryData.photos});
    // }
    this.renderGallery();
  }

  setAllImagesRemoved() {

    if (utils.isDev()) {
      console.log('Gallery Services - setAllImagesRemoved');
    }

    try {
      this.galleryData.photos = window.manuallySetImages = [];
      this.itemsCount = 0;
      this.galleryDataSrc = this.gallerySrcTypes.manuallySetImages;
    } catch (e) {
      console.error("Cannot set new images", e, window);
    }
    // if (this.galleryView) {
    //   this.galleryView.renderTrigger = this.galleryView.renderTriggers.ITEMS; //this is a patch, we need to find a better way to control setState without predefined data
    //   this.galleryView.totalItemsCount = this.itemsCount;
    //   this.galleryView.setState({items: this.galleryData.photos});
    // }
    this.renderGallery();
  }

  addImages(images, shouldAddToStart) {
    //update selected images in the current set of images on the window

    if (utils.isDev()) {
      console.log('Gallery Services - addImages', images, shouldAddToStart);
    }

    if (typeof images != 'object') {
      console.error('Trying to use addImages with illegal images', images);
    }
    if (!this.galleryData) {
      this.populateGalleryData();
    }
    if (!(images.length > 0)) {
      images = [images];
    }

    var firstArray = this.galleryData.photos;
    var secondArray = images;

    if (shouldAddToStart) {
      firstArray = images;
      secondArray = this.galleryData.photos;
    }

    try {
      this.setImages(firstArray.concat(secondArray));
    } catch (e) {
      console.error("Cannot add new images", e, images, window);
    }
  }

  reRenderGalleryForAlbums() {

    if (utils.isDev()) {
      console.log('Gallery Services - reRenderGalleryForAlbums');
    }

    this.populateGalleryData();
    // if (this.galleryView) {
    //   this.galleryView.renderTrigger = this.galleryView.renderTriggers.ITEMS; //this is a patch, we need to find a better way to control setState without predefined data
    //   this.galleryView.setState({items: this.galleryData.photos});
    // }
    this.renderGallery();
    //window.dispatchEvent(this.galleryScrollEvent);
  }

  renderGallery() {
    if (this.content) {
      if (utils.isDev()) {
        console.log('gallery Services renderGallery called', this.galleryData, this.itemsCount, this.store);
      }

      const layout = {
        width: window.innerWidth,
        height: window.innerHeight
      }

      render(<Provider store={this.store}>
            <div>
              <GalleryContainer
                  at={Date.now()} //forces the galleryContainer to reRender even if the itemsCount did not chage
                  items={this.galleryData['photos']}
                  galleryDataSrc={this.galleryDataSrc}
                  totalItemsCount={this.itemsCount}
                  store={this.store}
                  layout={layout}
              />
            </div>
          </Provider>,
          this.content);
    } else {
      //in karma, this file is loaded but there is no document
      //console.error('Missing content element for react');
    }
  }
}

//this should not be accessed by anyone from the outside - everything should be done via post message
var proGalleryServices = window['proGalleryServices'] = new ProGalleryServices();

window.addEventListener('message', function (e) {
  if (e && e.data === 'albumSetImagesUpdated') {

    console.log('message albumSetImagesUpdated arrived for gallery ', e);
    proGalleryServices.reRenderGalleryForAlbums();
  }
});



// WEBPACK FOOTER //
// ./components/gallery/galleryServices.js